module.exports = __webpack_public_path__ + "img/logo.0b566a92.png";